import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import { Box, Stack, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export type RequiredActionItem = {
  id: string;
  message?: string;
  actions: ReactNode;
};

type RequiredActionsSectionProps = {
  title: string;
  actions: RequiredActionItem[];
};

const RequiredActionsSection = ({ title, actions }: RequiredActionsSectionProps) => {
  if (!actions.length) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" color="primary" mb={1.5}>
        {title}
      </Typography>
      <Stack spacing={1.5}>
        {actions.map(action => (
          <Box key={action.id}>
            {action.message ? (
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1.5}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
              >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ flexGrow: 1 }}>
                  <WarningAmberOutlined color="error" fontSize="small" />
                  <Typography variant="body1">{action.message}</Typography>
                </Stack>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { lg: 'column', xl: 'row' },
                    gap: 1,
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  {action.actions}
                </Box>
              </Stack>
            ) : (
              action.actions
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default RequiredActionsSection;
